import { TCalculatorBonus } from '@libs/types';
import { numberFormat } from '@libs/utils';
import React, { MouseEvent } from 'react';
import { ButtonCircleView } from '../../Buttons/ButtonCircleView';
import { FeeBlock } from './FeeBlock';

type TFeePanelProps = {
    bonus: TCalculatorBonus;
    label: string;
    onClick?: (e: MouseEvent<HTMLButtonElement>) => void;
};

const Bonus = React.memo(({ bonus, label, onClick }: TFeePanelProps) => {
    const prefix = (() => {
        switch (bonus.direction) {
            case 'PLUS':
                return '+';
            case 'MINUS':
                return '-';
            default:
                return '';
        }
    })();

    return (
        <FeeBlock
            icon={
                bonus.iconName ? (
                    <ButtonCircleView
                        hierarchy={'tertiary'}
                        size={'small'}
                        iconName={bonus.iconName}
                        iconWidth={16}
                        iconHeight={16}
                        iconColor="var(--color-grey_72_lc)"
                        onClick={onClick}
                        margin={{ top: -5 }}
                    />
                ) : null
            }
            title={label ?? ''}
            text={`${prefix}${numberFormat(bonus.sum) as string} ${bonus.currency?.toUpperCase()}`}
            textColor="var(--color-purple_100)"
        />
    );
});
export { Bonus };
